/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './BarListStyles.scss';
const BASE_CLASS = 'qmb-ui-bar-list';
export function BarList({ items, color = '#B14F6B', className }) {
    const maxValue = items.length > 0 ? Math.max(...items.map((i) => i.value)) : 0;
    return (React.createElement("div", { className: classNames(BASE_CLASS, className) }, items.map((item) => (React.createElement("div", { key: item.label, className: `${BASE_CLASS}__row` },
        React.createElement("span", { className: `${BASE_CLASS}__label` }, item.label),
        React.createElement("div", { className: `${BASE_CLASS}__bar-container` },
            React.createElement("div", { className: `${BASE_CLASS}__bar`, style: {
                    width: maxValue > 0 ? `${(item.value / maxValue) * 100}%` : '0%',
                    backgroundColor: color
                } })),
        React.createElement("span", { className: `${BASE_CLASS}__value` }, item.value))))));
}
